import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import css from './index.css';

class RatioSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // value: '200mi',
      chooseArr: [50, 100, 150, 200, 300, 500],
      condition: true,
    };
    this.unfoldSelect = this.unfoldSelect.bind(this);
    this.downSelect = this.downSelect.bind(this);
    this.myFunction = this.myFunction.bind(this);
  }
  componentDidMount() {
    document.addEventListener('click', this.myFunction, false);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.myFunction, false);
  }
  myFunction() {
    this.setState({condition: true});
  }
  render() {
    const value = this.props.deadhead;
    return (
      <div className={cs(css.wrap)}>
        <span className={cs(css.wrapInput)} onClick={this.unfoldSelect}>{value}mi</span>
        <span className={cs(this.state.condition ? css.down : css.unfold)} onClick={this.unfoldSelect} />
        <ul className={cs(css.wrapUl)} style={{display: this.state.condition ? 'none' : 'block'}}>
          {this.state.chooseArr.map(k =>
            <li className={cs(css.wrapItem)} key={k} value={k} onClick={(event) => {this.downSelect(event, k);}}>{k}mi</li>
          )}
        </ul>
      </div>
    );
  }
  unfoldSelect(event) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition});
  }
  downSelect(event, k) {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    this.setState({condition: !this.state.condition});
    this.props.setDeadhead(k);
    this.props.update(k);
  }
}
export default connect((state, props) => ({
}))(RatioSelect);



// WEBPACK FOOTER //
// ./src/components/rate/common/ratioSelect/index.js